import { FC } from "react";
import { styled, Container, useTheme } from "@mui/material";
import { useSelector } from "src/store/Store";
import { Outlet } from "react-router-dom";
import { AppState } from "src/store/Store";
import Sidebar from "../layouts/sidebar/Sidebar";
import Header from "src/layouts/Header";


const MainWrapper = styled("div")(() => ({
  display: "flex",
  minHeight: "100vh",
  // maxHeight: "100vh",
  width: "100%",
  ".MuiContainer-root": {
    // 미디어 쿼리로 max-width 1200px 설정되어있어 해제
    maxWidth: "100%"
  }
}));

const PageWrapper = styled("div")(() => ({
  display: "flex",
  flexGrow: 1,
  paddingBottom: "60px",
  flexDirection: "column",
  zIndex: 1,
  width: "100%",
  backgroundColor: "transparent"
}));

const HomePage: FC = () => {
  const customizer = useSelector((state: AppState) => state.customizer);

  const theme = useTheme();

  return (
    <MainWrapper>
      {customizer.isHorizontal ? "" : <Sidebar />}

      <PageWrapper
        className="page-wrapper"
        sx={{
          ...(customizer.isCollapse && {
            [theme.breakpoints.up("lg")]: {
              ml: `${customizer.MiniSidebarWidth}px`
            }
          })
        }}
      >
        <Header />
        <Container
          sx={{
            maxWidth: customizer.isLayout === "boxed" ? "lg" : "100%"
            // overflow: 'auto'
          }}
        >
          <Outlet />
        </Container>
      </PageWrapper>
    </MainWrapper>
  );
};

export default HomePage;
